<template>
  <div class="fmRadio">
    <p>Ваш пол:</p>
    <label v-for="(inpt, index) in item.selectOption" :key="index">
      <div class="fmRadioStyle">
        <input type="radio" v-model.trim="value" :value="inpt.valueOption" v-on:change="cdTrigger">
        <div class="visualCheckBox" v-bind:class="{active: inpt.valueOption == value}">
          <IconBase  viewBox="0 0 12.828 8.414">
            <chekbox></chekbox>
          </IconBase>
        </div>
      </div>
      <span>{{inpt.nameOption}}</span>
    </label>
    <p class="errorMsg" v-if="statusVuex[refs].ShowError">{{errorMsg}}</p>
  </div>
</template>

<script>
  import DataForInput from '@/store/Form/longFormOptions';
  import { mapState} from 'vuex'

  export default {
    name: "fmRadio",
    props: {
      refs:{
        type:String,
        default:'',
      }
    },
    data: function () {
      return {
        item: DataForInput[this.refs],
      }
    },
    components:{
      chekbox:()=>import('@/components/svg/chekbox'),
      IconBase: () => import('@/components/svg/IconBase'),
    },
    methods:{
      cdTrigger(){
        this.$palantir.trackInputBlur(this.refs,this.valueVuex[this.refs]);
      }
    },
    computed:{
      ...mapState({
        valueVuex: state => state.Form.sendData,
        statusVuex: state => state.Form.workData
      }),
      value:{
        get(){
          return this.valueVuex[this.refs]
        },
        set(value){
          let utiputi = {
            target:this.refs,
            value: value
          };
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      errorMsg :function(){
        return this.statusVuex[this.refs].msg;
      }
    },

  }
</script>

<style scoped>
  .fmRadio{padding: 3vw 3vw 5vw;display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap}
  .fmRadio > p:first-child{font-size: 5vw;font-weight: bold;width: 100%;padding-bottom: 3vw;}
  .fmRadio label{display: flex;align-items: center;justify-content: flex-start;position: relative;padding-right: 3vw;font-size:4.4vw;font-weight: bold;height: 7vw;cursor: pointer}
  .fmRadioStyle input{width: 8vw;opacity: 0;}
  .visualCheckBox{width: 5vw;height: 5vw;display: flex;align-items:center;position:absolute;top:0;left:0;
    justify-content: center;width: 6vw;height: 6vw;border-radius: 2px;border: 1px solid #0a4d3a;pointer-events: none}
  .fmRadioStyle{position: relative}
  .visualCheckBox svg{width: 3.2vw;height: 1.9vw;opacity: 0;stroke: #0a4d3a}
  .visualCheckBox.active svg{opacity: 1;}

  @media screen and (min-width: 760px) {
    .fmRadio{padding: 1.5vw 1.1vw 1vw;}
    .fmRadio  > p:first-child{font-size: 1.4vw;width: auto;padding: 0 1vw 0 0;}
    .fmRadio label{font-size:1.3vw;height: 2vw;}
    .fmRadioStyle input{width: 2.3vw;height: 2vw;}
    .visualCheckBox{width: 1.6vw;height: 1.6vw;top:-0.2vw}
    .visualCheckBox svg{ width: 0.9vw;height: 0.6vw;}
    .visualCheckBox.active svg{}
  }

  @media screen and (min-width: 1140px) {
    .fmRadio{padding: 5px 13px 5px;}
    .fmRadio  > p:first-child{font-size: 18px;padding: 0 10px 0 0;}
    .fmRadio label{font-size: 16px;height: 30px;padding: 0 20px 0 0;}
    .fmRadioStyle{}
    .fmRadioStyle input{width: 30px;height: 25px;}
    .visualCheckBox{width: 25px;height: 25px;top:0;}
    .visualCheckBox svg{width: 10px;height: 6px;}
  }
</style>
